import React from "react"
import './sections.css';


export default function Section2()
{
return(
    <section>
  <div className="row w-100">
    <div className="col-12 col-sm-5 ms-xs-5">
<img src="./assets/svgs/Collecting-pana.svg" alt="Collecting-pana" className="Collecting-pana" />

</div>

    <div className="col-12 col-sm-5 mt-5 ms-xs-5 RightSection">
<h4 className="section2-header mt-md-5 FirstText">Become Pioneers and Build with Us!</h4>

<p className="section2-fp SecondText">Legaci is a new private social media app that allows you to build your private life story, save all your memories, send them to the future, and create albums with friends and family with all your shared memories, together.</p>
<p className="section2-fp ThirdText">By joining us today, you will become the first exclusive users to help build Legaci, as well as having access to all our feautures for free. FOREVER! <br></br> <br></br>Who’s With Us?</p>


    </div>
  </div>


</section>

)
}